"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentLimitsAssertions = exports.LimitsComponentValidated = exports.LimitsCapacitanceEqualsRequired = exports.LimitsCapacitanceMinMet = exports.LimitsCapacitanceMaxNotExceeded = exports.LimitsInductanceEqualsRequired = exports.LimitsInductanceMinMet = exports.LimitsInductanceMaxNotExceeded = exports.LimitsResistanceEqualsRequired = exports.LimitsResistanceMinMet = exports.LimitsResistanceMaxNotExceeded = exports.LimitsFrequencyEqualsRequired = exports.LimitsFrequencyMinMet = exports.LimitsFrequencyMaxNotExceeded = exports.LimitsTemperatureEqualsRequired = exports.LimitsTemperatureMinMet = exports.LimitsTemperatureMaxNotExceeded = exports.LimitsPowerEqualsRequired = exports.LimitsPowerMinMet = exports.LimitsPowerMaxNotExceeded = exports.LimitsCurrentEqualsRequired = exports.LimitsCurrentMinMet = exports.LimitsCurrentMaxNotExceeded = exports.LimitsVoltageEqualsRequired = exports.LimitsVoltageMinMet = exports.LimitsVoltageMaxNotExceeded = exports.ComponentLimitsRequirement = void 0;
const enums_1 = require("../enums");
const COMPONENT_LIMITS_REQUIREMENT_ID = 'req_cadstromlimits0000000000000000000000';
exports.ComponentLimitsRequirement = {
    id: COMPONENT_LIMITS_REQUIREMENT_ID,
    slug: 'cadstrom.limits',
    slugPrefix: 'LIMS',
    name: 'Component Limits',
    description: 'Asserts that every signal of a component operates within its manufacturer-declared electrical limits, checked against the resolved worst-case states of its connected nets. Evaluated on a per-pin basis.\n\n- **Absolute maximum ratings (AMR)** — limits beyond which the part risks damage; violations are reported as Errors.\n- **Recommended operating conditions (OC)** — the range within which the part is specified to function; violations are reported as Warnings.',
};
exports.LimitsVoltageMaxNotExceeded = {
    id: 'asrt_limitsvoltagemax00000000000000000000',
    slug: 'cadstrom.limits.voltage.max_not_exceeded',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Voltage must not exceed its maximum limit',
    description: 'The worst-case voltage at a component signal must not exceed its declared maximum.\n\n- Exceeding an **absolute maximum rating (AMR)** risks damage to the part and is reported as an Error.\n- Exceeding a **recommended operating maximum (OC)** leaves the range within which the part is specified to function and is reported as a Warning.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsVoltageMinMet = {
    id: 'asrt_limitsvoltagemin00000000000000000000',
    slug: 'cadstrom.limits.voltage.min_met',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Voltage must not fall below its minimum limit',
    description: 'The worst-case voltage at a component signal must not fall below its declared minimum.\n\n- Falling below an **absolute minimum rating (AMR)** (commonly a negative limit guarding against undershoot) risks damage to the part and is reported as an Error.\n- Falling below a **recommended operating minimum (OC)** leaves the range within which the part is specified to function and is reported as a Warning.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsVoltageEqualsRequired = {
    id: 'asrt_limitsvoltageeq000000000000000000000',
    slug: 'cadstrom.limits.voltage.equals_required',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Voltage must equal its required value',
    description: 'A component signal whose voltage is required to be a fixed value (optionally with a tolerance) must resolve to that value. AMR violations are reported as Errors; OC violations are reported as Warnings.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsCurrentMaxNotExceeded = {
    id: 'asrt_limitscurrentmax00000000000000000000',
    slug: 'cadstrom.limits.current.max_not_exceeded',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Current must not exceed its maximum limit',
    description: 'The worst-case current through a component signal must not exceed its declared maximum.\n\n- Exceeding an **absolute maximum rating (AMR)** (e.g. a maximum sink or source current) risks damage to the part and is reported as an Error.\n- Exceeding a **recommended operating maximum (OC)** leaves the range within which the part is specified to function and is reported as a Warning.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsCurrentMinMet = {
    id: 'asrt_limitscurrentmin00000000000000000000',
    slug: 'cadstrom.limits.current.min_met',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Current must not fall below its minimum limit',
    description: 'The worst-case current through a component signal must not fall below its declared minimum (e.g. a regulator minimum load current).\n\n- Falling below an **absolute minimum rating (AMR)** risks damage or undefined operation and is reported as an Error.\n- Falling below a **recommended operating minimum (OC)** leaves the range within which the part is specified to function and is reported as a Warning.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsCurrentEqualsRequired = {
    id: 'asrt_limitscurrenteq000000000000000000000',
    slug: 'cadstrom.limits.current.equals_required',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Current must equal its required value',
    description: 'A component signal whose current is required to be a fixed value (optionally with a tolerance) must resolve to that value. AMR violations are reported as Errors; OC violations are reported as Warnings.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsPowerMaxNotExceeded = {
    id: 'asrt_limitspowermax0000000000000000000000',
    slug: 'cadstrom.limits.power.max_not_exceeded',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Power dissipation must not exceed its maximum limit',
    description: 'The worst-case power dissipated at a component signal must not exceed its declared maximum.\n\n- Exceeding an **absolute maximum rating (AMR)** (e.g. a resistor power rating) risks damage to the part and is reported as an Error.\n- Exceeding a **recommended operating maximum (OC)** leaves the range within which the part is specified to function and is reported as a Warning.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsPowerMinMet = {
    id: 'asrt_limitspowermin0000000000000000000000',
    slug: 'cadstrom.limits.power.min_met',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Power dissipation must not fall below its minimum limit',
    description: 'The worst-case power dissipated at a component signal must not fall below its declared minimum. AMR violations are reported as Errors; OC violations are reported as Warnings.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsPowerEqualsRequired = {
    id: 'asrt_limitspowereq00000000000000000000000',
    slug: 'cadstrom.limits.power.equals_required',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Power dissipation must equal its required value',
    description: 'A component signal whose power dissipation is required to be a fixed value (optionally with a tolerance) must resolve to that value. AMR violations are reported as Errors; OC violations are reported as Warnings.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsTemperatureMaxNotExceeded = {
    id: 'asrt_limitstempmax00000000000000000000000',
    slug: 'cadstrom.limits.temperature.max_not_exceeded',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Temperature must not exceed its maximum limit',
    description: 'The worst-case temperature at a component signal must not exceed its declared maximum, regardless of the unit the limit is declared in.\n\n- Exceeding an **absolute maximum rating (AMR)** (e.g. a maximum junction temperature) risks damage to the part and is reported as an Error.\n- Exceeding a **recommended operating maximum (OC)** leaves the range within which the part is specified to function and is reported as a Warning.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsTemperatureMinMet = {
    id: 'asrt_limitstempmin00000000000000000000000',
    slug: 'cadstrom.limits.temperature.min_met',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Temperature must not fall below its minimum limit',
    description: 'The worst-case temperature at a component signal must not fall below its declared minimum, regardless of the unit the limit is declared in. AMR violations are reported as Errors; OC violations are reported as Warnings.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsTemperatureEqualsRequired = {
    id: 'asrt_limitstempeq000000000000000000000000',
    slug: 'cadstrom.limits.temperature.equals_required',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Temperature must equal its required value',
    description: 'A component signal whose temperature is required to be a fixed value (optionally with a tolerance) must resolve to that value. AMR violations are reported as Errors; OC violations are reported as Warnings.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsFrequencyMaxNotExceeded = {
    id: 'asrt_limitsfreqmax00000000000000000000000',
    slug: 'cadstrom.limits.frequency.max_not_exceeded',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Frequency must not exceed its maximum limit',
    description: 'The worst-case frequency at a component signal must not exceed its declared maximum.\n\n- Exceeding an **absolute maximum rating (AMR)** risks damage to the part and is reported as an Error.\n- Exceeding a **recommended operating maximum (OC)** leaves the range within which the part is specified to function and is reported as a Warning.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsFrequencyMinMet = {
    id: 'asrt_limitsfreqmin00000000000000000000000',
    slug: 'cadstrom.limits.frequency.min_met',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Frequency must not fall below its minimum limit',
    description: 'The worst-case frequency at a component signal must not fall below its declared minimum. AMR violations are reported as Errors; OC violations are reported as Warnings.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsFrequencyEqualsRequired = {
    id: 'asrt_limitsfreqeq000000000000000000000000',
    slug: 'cadstrom.limits.frequency.equals_required',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Frequency must equal its required value',
    description: 'A component signal whose frequency is required to be a fixed value (optionally with a tolerance) must resolve to that value. AMR violations are reported as Errors; OC violations are reported as Warnings.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsResistanceMaxNotExceeded = {
    id: 'asrt_limitsresmax000000000000000000000000',
    slug: 'cadstrom.limits.resistance.max_not_exceeded',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Resistance must not exceed its maximum limit',
    description: 'The worst-case resistance at a component signal must not exceed its declared maximum.\n\n- Exceeding an **absolute maximum rating (AMR)** risks damage to the part and is reported as an Error.\n- Exceeding a **recommended operating maximum (OC)** leaves the range within which the part is specified to function and is reported as a Warning.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsResistanceMinMet = {
    id: 'asrt_limitsresmin000000000000000000000000',
    slug: 'cadstrom.limits.resistance.min_met',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Resistance must not fall below its minimum limit',
    description: 'The worst-case resistance at a component signal must not fall below its declared minimum. AMR violations are reported as Errors; OC violations are reported as Warnings.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsResistanceEqualsRequired = {
    id: 'asrt_limitsreseq0000000000000000000000000',
    slug: 'cadstrom.limits.resistance.equals_required',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Resistance must equal its required value',
    description: 'A component signal whose resistance is required to be a fixed value (optionally with a tolerance) must resolve to that value. AMR violations are reported as Errors; OC violations are reported as Warnings.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsInductanceMaxNotExceeded = {
    id: 'asrt_limitsindmax000000000000000000000000',
    slug: 'cadstrom.limits.inductance.max_not_exceeded',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Inductance must not exceed its maximum limit',
    description: 'The worst-case inductance at a component signal must not exceed its declared maximum.\n\n- Exceeding an **absolute maximum rating (AMR)** risks damage to the part and is reported as an Error.\n- Exceeding a **recommended operating maximum (OC)** leaves the range within which the part is specified to function and is reported as a Warning.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsInductanceMinMet = {
    id: 'asrt_limitsindmin000000000000000000000000',
    slug: 'cadstrom.limits.inductance.min_met',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Inductance must not fall below its minimum limit',
    description: 'The worst-case inductance at a component signal must not fall below its declared minimum. AMR violations are reported as Errors; OC violations are reported as Warnings.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsInductanceEqualsRequired = {
    id: 'asrt_limitsindeq0000000000000000000000000',
    slug: 'cadstrom.limits.inductance.equals_required',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Inductance must equal its required value',
    description: 'A component signal whose inductance is required to be a fixed value (optionally with a tolerance) must resolve to that value. AMR violations are reported as Errors; OC violations are reported as Warnings.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsCapacitanceMaxNotExceeded = {
    id: 'asrt_limitscapmax000000000000000000000000',
    slug: 'cadstrom.limits.capacitance.max_not_exceeded',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Capacitance must not exceed its maximum limit',
    description: 'The worst-case capacitance at a component signal must not exceed its declared maximum.\n\n- Exceeding an **absolute maximum rating (AMR)** risks damage to the part and is reported as an Error.\n- Exceeding a **recommended operating maximum (OC)** leaves the range within which the part is specified to function and is reported as a Warning.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsCapacitanceMinMet = {
    id: 'asrt_limitscapmin000000000000000000000000',
    slug: 'cadstrom.limits.capacitance.min_met',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Capacitance must not fall below its minimum limit',
    description: 'The worst-case capacitance at a component signal must not fall below its declared minimum. AMR violations are reported as Errors; OC violations are reported as Warnings.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsCapacitanceEqualsRequired = {
    id: 'asrt_limitscapeq0000000000000000000000000',
    slug: 'cadstrom.limits.capacitance.equals_required',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Capacitance must equal its required value',
    description: 'A component signal whose capacitance is required to be a fixed value (optionally with a tolerance) must resolve to that value. AMR violations are reported as Errors; OC violations are reported as Warnings.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.LimitsComponentValidated = {
    id: 'asrt_limitscomponentval000000000000000000',
    slug: 'cadstrom.limits.component.limits_validated',
    requirementDefinitionId: COMPONENT_LIMITS_REQUIREMENT_ID,
    name: 'Component limits must be validated',
    description: 'A component must declare electrical limits, and the analysis must be able to check them against the resolved worst-case states of its connected nets. Evaluated once per component; resolves Indeterminate when the component has no usable limits data or when one or more of its net states could not be resolved. A violation that cannot be attributed to a specific signal is carried here.',
    lifecycle: enums_1.AssertionDefinitionLifecycle.Active,
};
exports.ComponentLimitsAssertions = [
    exports.LimitsVoltageMaxNotExceeded,
    exports.LimitsVoltageMinMet,
    exports.LimitsVoltageEqualsRequired,
    exports.LimitsCurrentMaxNotExceeded,
    exports.LimitsCurrentMinMet,
    exports.LimitsCurrentEqualsRequired,
    exports.LimitsPowerMaxNotExceeded,
    exports.LimitsPowerMinMet,
    exports.LimitsPowerEqualsRequired,
    exports.LimitsTemperatureMaxNotExceeded,
    exports.LimitsTemperatureMinMet,
    exports.LimitsTemperatureEqualsRequired,
    exports.LimitsFrequencyMaxNotExceeded,
    exports.LimitsFrequencyMinMet,
    exports.LimitsFrequencyEqualsRequired,
    exports.LimitsResistanceMaxNotExceeded,
    exports.LimitsResistanceMinMet,
    exports.LimitsResistanceEqualsRequired,
    exports.LimitsInductanceMaxNotExceeded,
    exports.LimitsInductanceMinMet,
    exports.LimitsInductanceEqualsRequired,
    exports.LimitsCapacitanceMaxNotExceeded,
    exports.LimitsCapacitanceMinMet,
    exports.LimitsCapacitanceEqualsRequired,
    exports.LimitsComponentValidated,
];
//# sourceMappingURL=component-limits.js.map